<template>
  <!-- 核心能力示意图：按 name 切换不同 SVG 分组（真实 GIF 到位后由 imgBase 覆盖） -->
  <svg class="cd-feat-svg" viewBox="0 0 380 150" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="cdgNode" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#2a7c7e"/>
        <stop offset="100%" stop-color="#0B2A4A"/>
      </linearGradient>
      <linearGradient id="cdgBar" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#4a9ea0"/>
        <stop offset="100%" stop-color="#0D4A6E"/>
      </linearGradient>
    </defs>

    <!-- 1. 多源融合检测 -->
    <g v-if="name === 'fusion'">
      <rect x="12" y="24" width="70" height="26" rx="5" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.2"/>
      <text x="47" y="41" font-size="11" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">声音</text>
      <rect x="12" y="62" width="70" height="26" rx="5" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.2"/>
      <text x="47" y="79" font-size="11" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">视觉</text>
      <rect x="12" y="100" width="70" height="26" rx="5" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.2"/>
      <text x="47" y="117" font-size="11" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">设备状态</text>

      <path d="M82,37 Q128,37 152,75" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <path d="M82,75 L152,75" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <path d="M82,113 Q128,113 152,75" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>

      <circle r="3" fill="#2a7c7e">
        <animateMotion dur="2s" repeatCount="indefinite" path="M82,37 Q128,37 152,75"/>
      </circle>
      <circle r="3" fill="#0B2A4A">
        <animateMotion dur="2.4s" repeatCount="indefinite" path="M82,113 Q128,113 152,75"/>
      </circle>

      <rect x="152" y="50" width="92" height="50" rx="8" fill="url(#cdgNode)"/>
      <text x="198" y="71" font-size="12" font-weight="700" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">融合判定</text>
      <text x="198" y="88" font-size="9" fill="#cbd5e1" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">P1-P5 + AI + 视觉</text>

      <path d="M244,75 L272,75" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <rect x="272" y="56" width="46" height="34" rx="6" fill="#e8f5e9" stroke="#16a34a" stroke-width="1.2"/>
      <text x="295" y="78" font-size="13" font-weight="700" fill="#16a34a" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">OK</text>
      <rect x="324" y="56" width="44" height="34" rx="6" fill="#fdecea" stroke="#dc2626" stroke-width="1.2"/>
      <text x="346" y="78" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">NG</text>
    </g>

    <!-- 2. AI声纹识别 -->
    <g v-else-if="name === 'voiceprint'">
      <text x="16" y="24" font-size="11" font-weight="700" fill="#0B2A4A" font-family="'Microsoft YaHei',sans-serif">音频波形</text>
      <path d="M16,44 Q30,26 44,44 T72,44 T100,44 T128,44" stroke="#2a7c7e" stroke-width="1.6" fill="none"/>
      <path d="M128,44 Q142,62 156,44 T184,44 T212,44" stroke="#2a7c7e" stroke-width="1.6" fill="none" opacity="0.6"/>

      <text x="16" y="78" font-size="11" font-weight="700" fill="#0B2A4A" font-family="'Microsoft YaHei',sans-serif">梅尔频谱 / MFCC</text>
      <rect x="16" y="86" width="12" height="24" fill="url(#cdgBar)" opacity="0.85"/>
      <rect x="32" y="90" width="12" height="20" fill="url(#cdgBar)" opacity="0.7"/>
      <rect x="48" y="82" width="12" height="28" fill="url(#cdgBar)"/>
      <rect x="64" y="94" width="12" height="16" fill="url(#cdgBar)" opacity="0.55"/>
      <rect x="80" y="88" width="12" height="22" fill="url(#cdgBar)" opacity="0.75"/>
      <rect x="96" y="84" width="12" height="26" fill="url(#cdgBar)" opacity="0.9"/>
      <rect x="112" y="96" width="12" height="14" fill="url(#cdgBar)" opacity="0.5"/>

      <path d="M136,98 L168,98" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <circle r="3" fill="#2a7c7e">
        <animateMotion dur="1.8s" repeatCount="indefinite" path="M136,98 L168,98"/>
      </circle>

      <rect x="168" y="60" width="86" height="44" rx="7" fill="url(#cdgNode)"/>
      <text x="211" y="79" font-size="12" font-weight="700" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">Transformer</text>
      <text x="211" y="95" font-size="9" fill="#cbd5e1" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">本地推理 · 不出域</text>

      <path d="M254,82 L282,82" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <rect x="282" y="64" width="62" height="36" rx="6" fill="#e8f5e9" stroke="#16a34a" stroke-width="1.2"/>
      <text x="313" y="86" font-size="13" font-weight="700" fill="#16a34a" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">声纹判定</text>
    </g>

    <!-- 3. P1-P5 声学特征分析 -->
    <g v-else-if="name === 'p1p5'">
      <path d="M20,100 L48,100 L58,40 L74,40 L84,100 L140,100" stroke="#0B2A4A" stroke-width="2" fill="none"/>
      <polygon points="48,100 58,40 74,40 84,100" fill="#2a7c7e" opacity="0.18"/>

      <line x1="66" y1="40" x2="66" y2="118" stroke="#dc2626" stroke-width="1" stroke-dasharray="4 3"/>
      <text x="66" y="132" font-size="10" font-weight="700" fill="#dc2626" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">P1 峰值</text>

      <line x1="48" y1="112" x2="84" y2="112" stroke="#0D4A6E" stroke-width="1.2"/>
      <path d="M48,112 L54,109 L54,115 Z" fill="#0D4A6E"/>
      <path d="M84,112 L78,109 L78,115 Z" fill="#0D4A6E"/>
      <text x="66" y="124" font-size="9" fill="#0D4A6E" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">P2 宽度</text>

      <text x="100" y="60" font-size="10" fill="#2a7c7e" font-family="'Microsoft YaHei',sans-serif">P3 面积</text>
      <path d="M96,56 L104,66" stroke="#2a7c7e" stroke-width="1"/>

      <rect x="170" y="30" width="96" height="96" rx="8" fill="#f7f9fb" stroke="#cbd5e1" stroke-width="1.2"/>
      <text x="218" y="50" font-size="11" font-weight="700" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">五项联合判定</text>
      <text x="184" y="72" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P1 脉冲峰值</text>
      <text x="184" y="90" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P2 脉冲宽度</text>
      <text x="184" y="108" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P3 脉冲面积</text>
      <text x="278" y="72" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P4 面积/宽度</text>
      <text x="278" y="90" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P5 频谱质心</text>
      <path d="M276,68 L272,72 L280,72 Z" fill="#2a7c7e"/>

      <text x="292" y="34" font-size="9" fill="#94a3b8" font-family="'Microsoft YaHei',sans-serif">独立上下限</text>
      <text x="292" y="122" font-size="9" fill="#94a3b8" font-family="'Microsoft YaHei',sans-serif">联合通过率</text>
    </g>

    <!-- 4. 智能良率区间计算 -->
    <g v-else-if="name === 'yieldRange'">
      <ellipse cx="42" cy="40" rx="26" ry="9" fill="#0D4A6E"/>
      <path d="M16,40 L16,66 Q42,80 68,66 L68,40" fill="#0D4A6E" opacity="0.85"/>
      <ellipse cx="42" cy="66" rx="26" ry="9" fill="#0B2A4A"/>
      <text x="42" y="100" font-size="10" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">历史数据</text>

      <text x="88" y="30" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P1-P5 下限</text>
      <line x1="88" y1="42" x2="180" y2="42" stroke="#cbd5e1" stroke-width="3" stroke-linecap="round"/>
      <circle cx="118" cy="42" r="5" fill="#2a7c7e"/>
      <text x="88" y="70" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">P1-P5 上限</text>
      <line x1="88" y1="82" x2="180" y2="82" stroke="#cbd5e1" stroke-width="3" stroke-linecap="round"/>
      <circle cx="152" cy="82" r="5" fill="#0B2A4A"/>
      <text x="88" y="110" font-size="10" font-weight="700" fill="#2a7c7e" font-family="'Microsoft YaHei',sans-serif">目标良率 99.8%</text>

      <path d="M196,75 L226,75" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>

      <rect x="236" y="26" width="12" height="64" fill="url(#cdgBar)" opacity="0.6"/>
      <rect x="254" y="34" width="12" height="56" fill="url(#cdgBar)" opacity="0.7"/>
      <rect x="272" y="20" width="12" height="70" fill="url(#cdgBar)"/>
      <rect x="290" y="30" width="12" height="60" fill="url(#cdgBar)" opacity="0.8"/>
      <rect x="308" y="38" width="12" height="52" fill="url(#cdgBar)" opacity="0.65"/>
      <rect x="326" y="24" width="12" height="66" fill="url(#cdgBar)" opacity="0.9"/>
      <text x="292" y="108" font-size="10" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">每日良率柱形图</text>
      <text x="292" y="126" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">计算后自动刷新</text>
    </g>

    <!-- 5. 机器视觉检测 -->
    <g v-else-if="name === 'vision'">
      <rect x="14" y="52" width="52" height="34" rx="6" fill="url(#cdgNode)"/>
      <text x="40" y="73" font-size="11" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">摄像头</text>
      <path d="M66,60 L120,30 L120,110 L66,88 Z" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.2"/>

      <rect x="134" y="40" width="70" height="52" rx="4" fill="#fff" stroke="#0D4A6E" stroke-width="1.4"/>
      <rect x="140" y="46" width="30" height="24" rx="2" fill="none" stroke="#16a34a" stroke-width="1.6" stroke-dasharray="4 3"/>
      <rect x="176" y="66" width="24" height="20" rx="2" fill="none" stroke="#16a34a" stroke-width="1.6" stroke-dasharray="4 3"/>
      <text x="169" y="104" font-size="10" fill="#0D4A6E" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">视觉画面 + ROI</text>

      <path d="M122,66 L134,66" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <path d="M204,66 L226,66" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>

      <rect x="226" y="34" width="66" height="30" rx="5" fill="#e8f5e9" stroke="#16a34a" stroke-width="1.2"/>
      <text x="259" y="53" font-size="11" font-weight="700" fill="#16a34a" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">识别通过</text>
      <rect x="226" y="74" width="66" height="30" rx="5" fill="#fdecea" stroke="#dc2626" stroke-width="1.2"/>
      <text x="259" y="93" font-size="11" font-weight="700" fill="#dc2626" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">缺陷告警</text>

      <text x="304" y="60" font-size="9" fill="#64748b" font-family="'Microsoft YaHei',sans-serif">手势检测</text>
      <text x="304" y="76" font-size="9" fill="#64748b" font-family="'Microsoft YaHei',sans-serif">工件识别</text>
      <text x="304" y="92" font-size="9" fill="#64748b" font-family="'Microsoft YaHei',sans-serif">存图录像</text>
      <text x="120" y="130" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">视觉触发采集 · 与声音检测同步</text>
    </g>

    <!-- 6. 自动化产线控制 -->
    <g v-else-if="name === 'plc'">
      <rect x="14" y="46" width="66" height="46" rx="6" fill="url(#cdgNode)"/>
      <text x="47" y="66" font-size="12" font-weight="700" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">PLC</text>
      <text x="47" y="82" font-size="9" fill="#cbd5e1" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">产线控制</text>

      <path d="M80,69 L112,69" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <circle r="3" fill="#2a7c7e">
        <animateMotion dur="1.6s" repeatCount="indefinite" path="M80,69 L112,69"/>
      </circle>
      <circle r="3" fill="#0B2A4A">
        <animateMotion dur="1.6s" repeatCount="indefinite" path="M112,69 L80,69"/>
      </circle>

      <rect x="112" y="30" width="118" height="78" rx="6" fill="#f7f9fb" stroke="#0D4A6E" stroke-width="1.3"/>
      <text x="171" y="46" font-size="10" font-weight="700" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">测试触发方式</text>
      <text x="124" y="64" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">手动测试 / 自动测试</text>
      <text x="124" y="80" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">产线触发测试</text>
      <text x="124" y="96" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">扫码枪 / 读卡器</text>

      <path d="M230,69 L262,69" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>

      <circle cx="276" cy="69" r="9" fill="#dc2626"/>
      <circle cx="300" cy="69" r="9" fill="#f59e0b"/>
      <circle cx="324" cy="69" r="9" fill="#16a34a"/>
      <text x="300" y="100" font-size="9" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">三色状态灯</text>

      <text x="300" y="30" font-size="9" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">扫码枪 / 读卡器</text>
      <text x="47" y="118" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">手动 / 自动 / 产线触发</text>
    </g>

    <!-- 7. 数据追溯与质量管理 -->
    <g v-else-if="name === 'trace'">
      <ellipse cx="40" cy="42" rx="24" ry="8" fill="#0D4A6E"/>
      <path d="M16,42 L16,68 Q40,80 64,68 L64,42" fill="#0D4A6E" opacity="0.85"/>
      <ellipse cx="40" cy="68" rx="24" ry="8" fill="#0B2A4A"/>
      <text x="40" y="98" font-size="9" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">本地 + 线体</text>
      <text x="40" y="110" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">双通道写入</text>

      <rect x="80" y="30" width="34" height="22" rx="4" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.1"/>
      <text x="97" y="45" font-size="9" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">CSV</text>
      <rect x="80" y="58" width="34" height="22" rx="4" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.1"/>
      <text x="97" y="73" font-size="9" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">图片</text>
      <rect x="80" y="86" width="34" height="22" rx="4" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.1"/>
      <text x="97" y="101" font-size="9" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">视频</text>

      <path d="M114,70 L146,70" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>

      <rect x="146" y="24" width="212" height="90" rx="6" fill="#fff" stroke="#cbd5e1" stroke-width="1.2"/>
      <polyline points="160,92 184,80 208,84 232,62 256,68 280,48 304,54 328,38"
                fill="none" stroke="#2a7c7e" stroke-width="2"/>
      <circle cx="232" cy="62" r="3" fill="#0B2A4A"/>
      <circle cx="304" cy="54" r="3" fill="#0B2A4A"/>
      <text x="252" y="126" font-size="10" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">趋势图 / 良率统计 / 记录查询</text>
      <line x1="156" y1="104" x2="348" y2="104" stroke="#e8ecf1" stroke-width="1"/>
    </g>

    <!-- 8. 用户与安全管理 -->
    <g v-else-if="name === 'security'">
      <circle cx="46" cy="52" r="18" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.3"/>
      <circle cx="46" cy="46" r="6" fill="#0D4A6E"/>
      <path d="M34,66 Q46,54 58,66" fill="#0D4A6E" opacity="0.8"/>
      <text x="46" y="92" font-size="10" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">账号登录</text>

      <rect x="80" y="34" width="42" height="24" rx="12" fill="#e8f5e9" stroke="#16a34a" stroke-width="1.1"/>
      <text x="101" y="50" font-size="10" font-weight="700" fill="#16a34a" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">L1</text>
      <rect x="80" y="64" width="42" height="24" rx="12" fill="#fff7e6" stroke="#f59e0b" stroke-width="1.1"/>
      <text x="101" y="80" font-size="10" font-weight="700" fill="#f59e0b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">L2</text>
      <rect x="80" y="94" width="42" height="24" rx="12" fill="#eaf2fb" stroke="#0D4A6E" stroke-width="1.1"/>
      <text x="101" y="110" font-size="10" font-weight="700" fill="#0D4A6E" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">L3</text>

      <rect x="146" y="42" width="52" height="46" rx="6" fill="url(#cdgNode)"/>
      <path d="M162,60 L162,54 A10,10 0 0 1 182,54 L182,60" fill="none" stroke="#fff" stroke-width="2"/>
      <rect x="158" y="60" width="28" height="20" rx="3" fill="#fff"/>
      <circle cx="172" cy="70" r="3" fill="#0B2A4A"/>
      <text x="172" y="104" font-size="9" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">权限管控</text>

      <rect x="216" y="34" width="142" height="60" rx="6" fill="#f7f9fb" stroke="#cbd5e1" stroke-width="1.1"/>
      <text x="230" y="52" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">PBKDF2-SHA256 哈希</text>
      <text x="230" y="70" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">DPAPI 加密口令</text>
      <text x="230" y="88" font-size="10" fill="#555" font-family="'Microsoft YaHei',sans-serif">未登录隐藏用户管理</text>
      <text x="287" y="116" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">L1 / L2 / L3 三级权限体系</text>
    </g>

    <!-- 9. 设备配置与维护 -->
    <g v-else-if="name === 'device'">
      <rect x="14" y="34" width="56" height="34" rx="17" fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.2"/>
      <text x="42" y="55" font-size="10" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">麦克风</text>
      <path d="M30,80 L38,88 L54,66" fill="none" stroke="#16a34a" stroke-width="2.4" stroke-linecap="round"/>
      <text x="42" y="106" font-size="9" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">自检通过</text>

      <text x="88" y="30" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">传感器校准</text>
      <line x1="88" y1="46" x2="176" y2="46" stroke="#cbd5e1" stroke-width="3" stroke-linecap="round"/>
      <circle cx="126" cy="46" r="5" fill="#2a7c7e"/>
      <text x="88" y="72" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">采集参数配置</text>
      <line x1="88" y1="88" x2="176" y2="88" stroke="#cbd5e1" stroke-width="3" stroke-linecap="round"/>
      <circle cx="152" cy="88" r="5" fill="#0B2A4A"/>

      <rect x="196" y="34" width="66" height="46" rx="5" fill="#fff" stroke="#0D4A6E" stroke-width="1.3"/>
      <rect x="203" y="41" width="26" height="20" rx="2" fill="none" stroke="#2a7c7e" stroke-width="1.4" stroke-dasharray="4 3"/>
      <text x="229" y="94" font-size="9" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">视觉区域配置</text>

      <circle cx="292" cy="52" r="9" fill="#dc2626"/>
      <circle cx="316" cy="52" r="9" fill="#f59e0b"/>
      <circle cx="340" cy="52" r="9" fill="#16a34a"/>
      <text x="316" y="80" font-size="9" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">三色状态灯</text>

      <text x="196" y="126" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">产品型号 / 测试配方 / 作业指导窗口</text>
    </g>

    <!-- 10. Modbus TCP 产线通讯 -->
    <g v-else-if="name === 'modbus'">
      <rect x="12" y="44" width="88" height="52" rx="7" fill="url(#cdgNode)"/>
      <text x="56" y="66" font-size="12" font-weight="700" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">声纹机</text>
      <text x="56" y="84" font-size="9" fill="#cbd5e1" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">Modbus 服务器</text>

      <path d="M100,70 L118,70" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <circle r="3" fill="#2a7c7e">
        <animateMotion dur="1.6s" repeatCount="indefinite" path="M100,70 L118,70"/>
      </circle>
      <circle r="3" fill="#0B2A4A">
        <animateMotion dur="1.6s" repeatCount="indefinite" path="M118,70 L100,70"/>
      </circle>

      <rect x="118" y="22" width="140" height="96" rx="6" fill="#f7f9fb" stroke="#0D4A6E" stroke-width="1.2"/>
      <text x="188" y="38" font-size="10" font-weight="700" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">寄存器地址区</text>
      <text x="128" y="56" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">1 声纹机心跳</text>
      <text x="128" y="74" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">2 包体类型</text>
      <text x="128" y="92" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">3 FID 码</text>
      <text x="196" y="56" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">4 包体码</text>
      <text x="196" y="74" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">5 请求测试信号</text>
      <text x="196" y="92" font-size="9" fill="#555" font-family="'Microsoft YaHei',sans-serif">6 测试完成信号</text>
      <text x="188" y="110" font-size="8.5" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">开辟地址 · 双向读写</text>

      <path d="M258,70 L280,70" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <circle r="3" fill="#2a7c7e">
        <animateMotion dur="1.8s" repeatCount="indefinite" path="M258,70 L280,70"/>
      </circle>
      <circle r="3" fill="#0B2A4A">
        <animateMotion dur="1.8s" repeatCount="indefinite" path="M280,70 L258,70"/>
      </circle>

      <rect x="280" y="44" width="88" height="52" rx="7" fill="#fff" stroke="#0D4A6E" stroke-width="1.4"/>
      <text x="324" y="66" font-size="12" font-weight="700" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">线体 PLC</text>
      <text x="324" y="84" font-size="9" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">请求 / 读取结果</text>
      <text x="188" y="136" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">Modbus TCP 协议交互</text>
    </g>

    <!-- 11. 双数据库部署 -->
    <g v-else-if="name === 'database'">
      <rect x="12" y="52" width="84" height="44" rx="6" fill="url(#cdgNode)"/>
      <text x="54" y="70" font-size="11" font-weight="700" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">声纹机</text>
      <text x="54" y="87" font-size="9" fill="#cbd5e1" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">检测结果</text>

      <path d="M96,66 Q136,66 172,42" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <path d="M96,82 Q136,82 172,94" stroke="#cbd5e1" stroke-width="1.4" fill="none"/>
      <circle r="3" fill="#2a7c7e">
        <animateMotion dur="1.8s" repeatCount="indefinite" path="M96,66 Q136,66 172,42"/>
      </circle>
      <circle r="3" fill="#0B2A4A">
        <animateMotion dur="2.2s" repeatCount="indefinite" path="M96,82 Q136,82 172,94"/>
      </circle>

      <text x="225" y="16" font-size="9" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">双通道写入</text>

      <ellipse cx="225" cy="28" rx="46" ry="8" fill="#0D4A6E"/>
      <path d="M179,28 L179,46 Q225,60 271,46 L271,28" fill="#0D4A6E" opacity="0.85"/>
      <ellipse cx="225" cy="46" rx="46" ry="8" fill="#0B2A4A"/>
      <text x="225" y="68" font-size="10.5" font-weight="700" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">本地数据库 · 声纹机电脑</text>
      <text x="284" y="40" font-size="8.5" fill="#94a3b8" font-family="'Microsoft YaHei',sans-serif">断线重连 / 手动上传</text>

      <ellipse cx="225" cy="88" rx="46" ry="8" fill="#2a7c7e"/>
      <path d="M179,88 L179,106 Q225,120 271,106 L271,88" fill="#2a7c7e" opacity="0.85"/>
      <ellipse cx="225" cy="106" rx="46" ry="8" fill="#0B2A4A"/>
      <text x="225" y="128" font-size="10.5" font-weight="700" fill="#0B2A4A" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">线体数据库 · 线体电脑</text>
      <text x="284" y="100" font-size="8.5" fill="#94a3b8" font-family="'Microsoft YaHei',sans-serif">供产线 / MES 读取</text>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CaseFeatSvg',
  props: {
    name: {type: String, default: ''}
  }
};
</script>
